import { DefaultState } from '@src/redux/types'

import * as actionTypes from '../constants/actionTypes'
import { SEMESTER_ALL } from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [actionTypes.SEMESTER_ALL]: DefaultState<`${typeof SEMESTER_ALL}`, 'get'>
} = () => ({
  [actionTypes.SEMESTER_ALL]: defaultState(),
})
